import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../lib/AuthContext";
import { CircleNotch, ArrowLeft, ArrowRight } from "@phosphor-icons/react";

export default function AdminActivity() {
  const { authFetch } = useAuth();
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${window.location.origin}/api/admin/activity?page=${page}&per_page=25`);
      if (res.ok) setData(await res.json());
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [authFetch, page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 lg:p-8 max-w-7xl mx-auto" data-testid="admin-activity">
      <h1 className="font-display font-bold text-2xl text-slate-900 mb-6">Admin Activity Log</h1>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {loading ? (
          <div className="p-12 text-center"><CircleNotch className="w-6 h-6 text-teal animate-spin mx-auto" /></div>
        ) : (data?.actions || []).length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-400">No admin actions recorded yet</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="text-left px-4 py-3 font-semibold text-slate-600">Action</th>
                  <th className="text-left px-4 py-3 font-semibold text-slate-600">Target User</th>
                  <th className="text-left px-4 py-3 font-semibold text-slate-600">Change</th>
                  <th className="text-left px-4 py-3 font-semibold text-slate-600">Notes</th>
                  <th className="text-left px-4 py-3 font-semibold text-slate-600">Date</th>
                </tr>
              </thead>
              <tbody>
                {data.actions.map((a, i) => (
                  <tr key={i} className="border-b border-slate-100 hover:bg-slate-50/50">
                    <td className="px-4 py-3"><span className="inline-flex px-2 py-0.5 bg-slate-100 text-slate-700 text-xs font-semibold rounded-full">{a.action_type}</span></td>
                    <td className="px-4 py-3 font-mono text-xs text-slate-500 max-w-[200px] truncate">{a.target_user_id || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{a.old_value && `${a.old_value} → `}{a.new_value || "—"}</td>
                    <td className="px-4 py-3 text-slate-500 max-w-[250px] truncate">{a.notes || "—"}</td>
                    <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{a.created_at ? new Date(a.created_at).toLocaleString() : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {data && data.total_pages > 1 && (
        <div className="flex items-center justify-between mt-4 text-sm text-slate-500">
          <span>Page {data.page} of {data.total_pages}</span>
          <div className="flex gap-2">
            <button disabled={page <= 1} onClick={() => setPage(p => p - 1)} className="px-3 py-1 border border-slate-200 rounded-lg disabled:opacity-40 flex items-center gap-1"><ArrowLeft className="w-3 h-3" /> Prev</button>
            <button disabled={page >= data.total_pages} onClick={() => setPage(p => p + 1)} className="px-3 py-1 border border-slate-200 rounded-lg disabled:opacity-40 flex items-center gap-1">Next <ArrowRight className="w-3 h-3" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
